import "./Selector.css"


function SelectorPlots({props, onSelect, isDisabled, resetDropdown1, resetDropdown2, resetDropdownValue}) {
   
    

    const handleChange = (event) =>{
        onSelect(event.target.value);
    
        if(resetDropdownValue){
            resetDropdownValue("")
        }
        if(resetDropdown1){
            resetDropdown1("")
            resetDropdown2("")
        }
    }

    
   
    return(
        <div id = "SelectorCustomClass">
            <p> <strong>{props.title}</strong> </p>
            <select className = "customSelect" defaultValue={'DEFAULT'}  aria-label=".form-select example" onChange = {handleChange} disabled = {isDisabled}  style={{ width: '300px' }}>
                <option value= "DEFAULT" disabled >{props.defaultText}</option>
                {props.options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
      

    );
}

export default SelectorPlots;